module.exports = __webpack_public_path__ + "static/media/logo_lk 1.35c257e8.svg";